// Page header for the gates view, same layout as the retail and concessions headers,
// with the Overview / Game Day tabs.
import React from 'react';
import SportIcon from '../../../components/atoms/SportIcon';
import Icon from '../../../components/atoms/Icon';
import GateIcon from './GateIcon';
import '../../Concession/concession.css';

const GatesHeader = ({ currentLocation, isToday, selectedDate, dayType, setDayType, loading }) => {
  const name = currentLocation?.name || 'Gates';
  const gates = currentLocation?.gates || [];
  // The eyebrow names the vertical; skip it when the location is itself called "Gates"
  const showEyebrow = name.trim().toLowerCase() !== 'gates';

  return (
    <div className="cx-header">
      <div className="cx-header-identity">
        {/* The venue's own gate icons, overlapping, in place of a logo. Any number of gates:
            the overlap tightens to fit, and the last icon always shows in full. */}
        {gates.length > 0 && (
          <>
            <div className="gx-hstack" aria-hidden="true">
              {gates.map((gate) => (
                <span className="gx-hstack-slot" key={gate.gateId}>
                  <GateIcon imageURL={gate.imageURL} label={gate.label || `Gate ${gate.gateId}`} className="gx-hstack-icon" />
                </span>
              ))}
            </div>
            <div className="cx-header-divider" />
          </>
        )}
        <div style={{ minWidth: 0 }}>
          {showEyebrow && <div className="cx-eyebrow">Gates</div>}
          <h1 className="cx-header-title">{name}</h1>
        </div>
      </div>

      <div className="cx-header-actions">
        {dayType === 'game' && isToday && selectedDate && (
          <span className="cx-live-pill">
            <span className="pulsing-dot" />
            Live
          </span>
        )}
        <div className="cx-segmented" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={dayType === 'overview'}
            disabled={loading}
            onClick={() => setDayType('overview')}
            className={`cx-segmented-btn ${dayType === 'overview' ? 'active' : ''}`}
          >
            <Icon name="graph-up" />
            Overview
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={dayType === 'game'}
            disabled={loading}
            onClick={() => setDayType('game')}
            className={`cx-segmented-btn ${dayType === 'game' ? 'active' : ''}`}
          >
            <SportIcon fontSize="inherit" />
            Game Day
          </button>
        </div>
      </div>
    </div>
  );
};

export default GatesHeader;
